<style>
.container-mis-rep {
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 20px;
}

.centered-content-mis-rep {
  padding: 20px;
  /*background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 8px;*/
  width: 100%;
  max-width: 250px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <!-- <b-card-header header-tag="header" class="p-1" role="tab"></b-card-header> -->
      <b-card-body>
        <div class="container-mis-rep">
          <div class="centered-content-mis-rep">
            <div style="font-weight:bold; margin-bottom:20px">Seleccione un Reporte</div>
            <div>
              <b-button class="btn btn-success" @click="GoToReporteOperaciones()">Resumen de Ventas</b-button>
            </div>
            <div v-if="Model.isCommerce" style="margin-top: 10px">
              <b-button class="btn btn-success" @click="GoToImpuestos()">Impuestos</b-button>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import store from "/src/store.js";

export default {
  components: {},
  data() {
    return {
      Model: {
        isCommerce: false
      }
    };
  },
  methods: {
    GoToReporteOperaciones() {
      let context = this;

      context.$router.push({
        name: "ReporteOperacionesSearchDates"
      });
    },
    GoToImpuestos() {
      let context = this;

      context.$router.push({
        name: "ReporteImpuestosSearchDates"
      });
    }
  },
  beforeMount: function() {
    let context = this;

    context.Model.isCommerce = store.getters.isCommerce;
  }
};
</script>